"use client";
import { useRef as I, useState as b, useEffect as l } from "react";
function w(i = {}) {
  const e = I(null), { triggerOnce: t = !1, ...r } = i, [c, u] = b(!1);
  return l(() => {
    const n = e.current;
    if (!n)
      return;
    const s = new IntersectionObserver(([f]) => {
      const o = f.isIntersecting;
      u(o), o && t && s.unobserve(n);
    }, r);
    return s.observe(n), () => {
      s.disconnect();
    };
  }, [e, t, r]), [e, c];
}
export {
  w as useIsInView
};
